import promoHasStarted from "./promoHasStarted";
import promoHasEnded from "./promoHasEnded";

const promoIsActive = () => {
  return promoHasStarted() && !promoHasEnded();
};

export default promoIsActive;